import { type ReactNode } from "react";
import { Typography } from "antd";
import './description.scss';

interface IJournalSectionDescriptionProps {
  children: ReactNode;
}

export const JournalSectionDescription = ({ children }: IJournalSectionDescriptionProps) => {
  return (

    <Typography.Paragraph
    className="journal-section-description"
    type="secondary"
  >
    {children}
  </Typography.Paragraph>
  );
};